import styled, { css } from 'styled-components';
import { paragraphStyle } from './textStyle';

const P = styled.p`
  ${paragraphStyle};

  ${props =>
    props.bold &&
    css`
      font-family: ${props => props.theme.fonts.fontfaceBold};
    `};

  ${props =>
    props.neutral &&
    css`
      color: ${props => props.theme.colors.xDarkgray};
    `};
`;

export default P;



// WEBPACK FOOTER //
// ./src/components/P/P.js